import { useMutation } from "@apollo/client"
import { TOURNAMENT_PLAYER_UPDATE } from "../queries/tournamentPlayerUpdate"

interface TournamentPlayerUpdateInput {
  id: number
  action: "delete" | "race" | "bye" | "change"
  raceId?: number
  bye?: boolean
  personId?: number
}

export const useTournamentPlayerUpdate = () => {
  const [updatePlayer, { loading, error }] = useMutation(TOURNAMENT_PLAYER_UPDATE)

  const updateTournamentPlayer = async (input: TournamentPlayerUpdateInput) => {
    try {
      const { data } = await updatePlayer({
        variables: {
          TournamentPlayerUpdateInput: input,
        },
      })
      return data?.TournamentPlayerUpdate
    } catch (err) {
      console.error("Error updating tournament player:", err)
      throw err
    }
  }

  return {
    updateTournamentPlayer,
    loading,
    error,
  }
}
